import { AuthLoginResponse } from '../../../sdk-member';
import { createAction, props } from '@ngrx/store';
import { AuthLoginModel } from './auth-login.state';
import { asyncProps, AsyncRequest, FromApiActionPayload, WithRequestId } from '../common';

/** StateDetailsActions */
const ACTION_SET = '[AuthLogin] set';
const ACTION_UPDATE = '[AuthLogin] update';
const ACTION_RESET = '[AuthLogin] reset';
const ACTION_FAIL = '[AuthLogin] fail';
const ACTION_CANCEL_REQUEST = '[AuthLogin] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[AuthLogin] set from api';
const ACTION_UPDATE_FROM_API = '[AuthLogin] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setAuthLogin = createAction(ACTION_SET, props<WithRequestId<AuthLoginModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateAuthLogin = createAction(ACTION_UPDATE, props<WithRequestId<Partial<AuthLoginModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetAuthLogin = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelAuthLoginRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failAuthLogin = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setAuthLoginFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<AuthLoginResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateAuthLoginFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<AuthLoginResponse>>()
);
